import { StyleData, SupportedMedia } from '@gsc/types'
import { useMemo } from 'preact/hooks'
import { WidgetInstance } from '../../types'
import { useMediaQueries } from '../useMediaQueries'

const mqMobile = `(max-width: ${MEDIA_BREAK}px)` // const mqDesktop = `(min-width: ${MEDIA_BREAK}px)`
const MEDIA_QUERIES = [mqMobile]

function mergeStyleData(targetMedia: SupportedMedia, ...sources: Array<Partial<StyleData>>): Partial<StyleData> {
  return [...sources]
    .filter(Boolean)
    .flatMap(({ media, ...s }) => [s, media?.[targetMedia]])
    .reduce<Partial<StyleData>>((res, curr = {}) => {
      const css = [res.css, curr.css].filter(Boolean).join('\n')
      const images = [...(res.images || []), ...(curr.images || [])]
      const colors = {
        ...res.colors,
        ...curr.colors,
      }
      return { ...res, ...curr, css, images, colors }
    }, {})
}

export function useStyleData(widget: WidgetInstance): Partial<StyleData> {
  const matches = useMediaQueries(MEDIA_QUERIES)
  const { style, activePage, pages } = widget
  const pageStyle = pages[activePage]?.style

  const media = matches[mqMobile] ? SupportedMedia.Mobile : SupportedMedia.Desktop

  return useMemo(() => mergeStyleData(media, style, pageStyle), [media, style, pageStyle])
}
